export default __webpack_public_path__ + "static/media/avatar-bts-rm.6f32d3df.png";